import React from 'react';
import Sparkle from './Sparkle';

const initials = (name) => (name || '?').trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join('').toUpperCase();

/** A featured-shop card: storefront screenshot (or branded placeholder) + name + visit link. */
const ShopCard = ({ shop }) => (
  <a
    href={shop.url}
    target="_blank"
    rel="noreferrer"
    className="group block bg-white border border-line rounded-3xl overflow-hidden hover:-translate-y-1.5 hover:shadow-card transition-all"
  >
    <div className="aspect-[4/3] bg-sky overflow-hidden">
      {shop.screenshot ? (
        <img
          src={shop.screenshot}
          alt={`${shop.name} — a store built on Shopstar`}
          loading="lazy"
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      ) : (
        <div className="relative w-full h-full grid place-items-center">
          <Sparkle size={26} color="#95a8e6" className="absolute top-4 right-4 opacity-50" />
          <div className="grid place-items-center w-16 h-16 rounded-2xl bg-white text-ink text-2xl font-extrabold shadow-soft">
            {initials(shop.name)}
          </div>
        </div>
      )}
    </div>
    <div className="flex items-center justify-between gap-3 p-5">
      <strong className="text-ink font-extrabold truncate">{shop.name}</strong>
      <span className="inline-flex items-center gap-1.5 flex-none text-ink font-bold text-sm group-hover:text-amber transition-colors">
        Visit
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"><path d="M7 17L17 7M9 7h8v8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </span>
    </div>
  </a>
);

export default ShopCard;
